/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRequestAppointmentModalLoader_user$ref = any;
export type PdpSharedBlurbTradeRequestAppointment_user$ref = any;
export type PdpSharedBlurbTradeRequestAppointment_user = {
    readonly tradeFirm: {
        readonly serviceId: string | null;
    } | null;
    readonly " $fragmentRefs": PdpRequestAppointmentModalLoader_user$ref;
    readonly " $refType": PdpSharedBlurbTradeRequestAppointment_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedBlurbTradeRequestAppointment_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirm",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRequestAppointmentModalLoader_user",
      "args": null
    }
  ]
};
(node as any).hash = '1365ea5813114e8c4a76d49f49bfbed0';
export default node;
